module.exports = __webpack_public_path__ + "static/img/extend_icon_white.062b1d4b.062b1d4b.svg";